var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_539_215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9966 4.35417C12.6191 4.35417 14.072 4.91333 15.2178 6.00417L18.3574 2.86458C16.4508 1.09083 13.962 0 10.9966 0C6.69742 0 2.98034 2.46583 1.16992 6.05917L4.82742 8.89625C5.69367 6.28833 8.12742 4.35417 10.9966 4.35417Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5325 11.2519C21.5325 10.5323 21.4637 9.83567 21.3583 9.1665H11V13.3007H16.9308C16.665 14.6573 15.895 15.8123 14.74 16.5915L18.2829 19.3415C20.35 17.4257 21.5325 14.5932 21.5325 11.2519Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.82625 13.1037C4.60625 12.4391 4.47792 11.7332 4.47792 10.9999C4.47792 10.2666 4.60167 9.56075 4.82625 8.89617L1.16875 6.05908C0.421667 7.54408 0 9.22158 0 10.9999C0 12.7782 0.421667 14.4557 1.17333 15.9407L4.82625 13.1037Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0012 22.0014C13.9712 22.0014 16.4691 21.0252 18.2841 19.3385L14.7412 16.5885C13.7558 17.2531 12.4862 17.6427 11.0012 17.6427C8.13201 17.6427 5.69826 15.7085 4.82742 13.1006L1.16992 15.9377C2.98492 19.5356 6.70201 22.0014 11.0012 22.0014Z",
    fill: "#34A853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_539_215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.b1ca24cbe1b7dcf93f493db9fe9f39c6.svg";
export { ForwardRef as ReactComponent };